import { Box, Card, CardActions, CardContent, Button, Typography, CardProps } from '@mui/material';
import styles from './BaseCard.module.scss';
import classNames from 'classnames/bind';
import { InprogressIcon, ArrowUpRightIcon } from '~/assets/icons';
type BaseCardProps = CardProps & {
  icon?: React.ReactNode,
  status: string,
  total: number,
  percent: number,
};

const cx = classNames.bind(styles);

const BaseCard = (props: BaseCardProps) => {

  return (
    <Card sx={{ minWidth: 275 }} className='rounded-[12px]'>
      <CardContent>
        {props?.icon}
        <Typography className='mb-[10px] text-[#646D8A] text-[12px]'>
          {props?.status}
        </Typography>
        <Typography className='text-[30px]' component="div">
          {props?.total}
        </Typography>
      </CardContent>
      <CardActions className='flex flex-end justify-end'>
        <Typography sx={{ fontSize: 14 }} className='flex items-center text-[#28BB10]' gutterBottom>
          <ArrowUpRightIcon className='w-[9px] h-[9px] mr-[4px]'/>  {props?.total}%
        </Typography>
      </CardActions>
    </Card>
  )
}

export default BaseCard
